import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateResourceArgs,
  BackendPerformanceCenterCustomerResource,
} from 'src/types/backend';

import { FRAGMENT_CUSTOMER_RESOURCE } from './schema';

const MUTATION = gql`
  mutation UpdateResource(
    $id: ID!
    $customerId: ID!
    $input: PerformanceCenterCustomerResourceUpdateInputType!
  ) {
    updateResource(id: $id, customerId: $customerId, input: $input) {
      ...PerformanceCenterCustomerResource
    }
  }
  ${FRAGMENT_CUSTOMER_RESOURCE}
`;

type Variables = BackendMutationUpdateResourceArgs;
type Result = BackendPerformanceCenterCustomerResource;

export const updateResource = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
